import { render, staticRenderFns } from "./ServicesIcon.vue?vue&type=template&id=3443e304"
import script from "./ServicesIcon.vue?vue&type=script&lang=js"
export * from "./ServicesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports